import React, { useState } from 'react';

import { Modal } from 'antd';

import Signature from '../../signature';

import '../styles.less';

const signatureModal = ({ rootContainer, closeModal, onSignatureCreate, truckingCompanyId }) => {
  const [onSaveCallback, setOnSaveCallback] = useState();
  const [saveLoading, setSaveLoading] = useState();
  const [saveButtonDisabled, setSaveButtonDisabled] = useState();

  const handleOk = () => {
    if (typeof onSaveCallback === 'function') {
      onSaveCallback();
    }
  };

  return (
    <Modal
      title="Create Signature"
      open={true}
      onOk={handleOk}
      okText={'Create'}
      onCancel={closeModal}
      okButtonProps={{ disabled: saveButtonDisabled }}
      getContainer={rootContainer}
      confirmLoading={saveLoading}
      width={624}
    >
      <Signature
        isModal={true}
        setOnSaveCallback={setOnSaveCallback}
        setSaveLoading={setSaveLoading}
        setSaveButtonDisabled={setSaveButtonDisabled}
        rootContainer={rootContainer}
        signatureCreateCallback={onSignatureCreate}
        cancelCallback={closeModal}
        truckingCompanyId={truckingCompanyId}
      />
    </Modal>
  );
};

export default signatureModal;
